import { render, staticRenderFns } from "./Defective.vue?vue&type=template&id=124fcc80&"
import script from "./Defective.vue?vue&type=script&lang=js&"
export * from "./Defective.vue?vue&type=script&lang=js&"
import style0 from "./Defective.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports